import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4907fa22"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  style: {"margin-bottom":"10px"},
  class: "container_title"
}
const _hoisted_3 = { class: "mediabuying-section-wrapper content-wrapper" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { style: {"margin-bottom":"10px"} }
const _hoisted_6 = { class: "sub" }
const _hoisted_7 = ["href"]
const _hoisted_8 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "17",
  height: "17",
  viewBox: "0 0 17 17",
  fill: "none"
}
const _hoisted_9 = ["fill"]
const _hoisted_10 = { class: "landing-dialog" }
const _hoisted_11 = { class: "landing-dialog" }
const _hoisted_12 = { class: "wrapper" }
const _hoisted_13 = { class: "send__form" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "17",
  height: "17",
  viewBox: "0 0 17 17",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M16.1421 1.49995C16.1421 0.947669 15.6944 0.499954 15.1421 0.499954L6.14214 0.499955C5.58985 0.499954 5.14214 0.94767 5.14214 1.49995C5.14214 2.05224 5.58985 2.49995 6.14214 2.49995L14.1421 2.49995L14.1421 10.5C14.1421 11.0522 14.5899 11.5 15.1421 11.5C15.6944 11.5 16.1421 11.0522 16.1421 10.5L16.1421 1.49995ZM1.70711 16.3492L15.8492 2.20706L14.435 0.792848L0.292893 14.935L1.70711 16.3492Z",
    fill: "black"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_form = _resolveComponent("q-form")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["section", `theme-${_ctx.activeService}`])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('landingMTClickbait.contact_form.title')), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.$t('landingMTClickbait.contact_form.title')), 1),
          _createElementVNode("h4", _hoisted_6, _toDisplayString(_ctx.$t('landingMTClickbait.contact_form.subTitle')), 1),
          _createElementVNode("a", {
            class: "contact_via_telegram",
            href: _ctx.getTelegramLink,
            target: "_blank"
          }, [
            _createElementVNode("span", null, [
              _createTextVNode(_toDisplayString(_ctx.$t('landingMTClickbait.contact_form.btnTelegram')) + " ", 1),
              (_openBlock(), _createElementBlock("svg", _hoisted_8, [
                _createElementVNode("path", {
                  d: "M16.1421 1.49995C16.1421 0.947669 15.6944 0.499954 15.1421 0.499954L6.14214 0.499955C5.58985 0.499954 5.14214 0.94767 5.14214 1.49995C5.14214 2.05224 5.58985 2.49995 6.14214 2.49995L14.1421 2.49995L14.1421 10.5C14.1421 11.0522 14.5899 11.5 15.1421 11.5C15.6944 11.5 16.1421 11.0522 16.1421 10.5L16.1421 1.49995ZM1.70711 16.3492L15.8492 2.20706L14.435 0.792848L0.292893 14.935L1.70711 16.3492Z",
                  fill: _ctx.activeColor
                }, null, 8, _hoisted_9)
              ]))
            ])
          ], 8, _hoisted_7)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_q_form, {
            ref: "form",
            style: {"width":"100%","max-width":"100%"},
            onSubmit: _ctx.onSubmit,
            onReset: _ctx.reset
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_q_select, {
                    modelValue: _ctx.contactMethod,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.contactMethod) = $event)),
                    options: _ctx.contactOptions,
                    "label-color": "white",
                    dense: "",
                    outlined: "",
                    label: _ctx.$t('contact_form.contact_method'),
                    rules: [_ctx.requiredField],
                    error: !!_ctx.errors.contactMethod,
                    "error-message": _ctx.errors.contactMethod,
                    onFocus: _cache[1] || (_cache[1] = 
                    () => {
                      _ctx.errors.contactMethod = ''
                    }
                  ),
                    "emit-value": "",
                    "map-options": ""
                  }, null, 8, ["modelValue", "options", "label", "rules", "error", "error-message"]),
                  _createVNode(_component_q_input, {
                    modelValue: _ctx.telegram,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.telegram) = $event)),
                    "label-color": "white",
                    dense: "",
                    outlined: "",
                    placeholder: _ctx.$t('contact_form.telegram'),
                    "lazy-rules": "",
                    rules: [_ctx.requiredField],
                    error: !!_ctx.errors.telegram,
                    "error-message": _ctx.errors.telegram,
                    onFocus: _cache[3] || (_cache[3] = 
                    () => {
                      _ctx.errors.telegram = ''
                    }
                  )
                  }, null, 8, ["modelValue", "placeholder", "rules", "error", "error-message"])
                ])
              ]),
              _createElementVNode("div", null, [
                _createVNode(_component_q_input, {
                  modelValue: _ctx.message,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.message) = $event)),
                  "label-color": "white",
                  type: "textarea",
                  dense: "",
                  outlined: "",
                  placeholder: _ctx.$t('contact_form.message'),
                  "lazy-rules": "",
                  rules: [_ctx.requiredField],
                  error: !!_ctx.errors.message,
                  "error-message": _ctx.errors.message,
                  onFocus: _cache[5] || (_cache[5] = 
                  () => {
                    _ctx.errors.message = ''
                  }
                )
                }, null, 8, ["modelValue", "placeholder", "rules", "error", "error-message"])
              ]),
              _createElementVNode("button", _hoisted_13, [
                _createElementVNode("span", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t('landingMTClickbait.contact_form.btnSendForm')) + " ", 1),
                  _hoisted_14
                ])
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "onReset"])
        ])
      ])
    ])
  ], 2))
}